module.exports = __webpack_public_path__ + "img/27.2cef4e30.png";